import { Component } from '@angular/core';

@Component({
  selector: 'app-healthcheck',
  templateUrl: './healthcheck.component.html',
})
export class HealthcheckComponent {
  constructor() {}
}
